import { withDevtools, withImmutableState, withStorageSync } from "@angular-architects/ngrx-toolkit";
import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { HighContrastService } from "@svs/core";

export type TextSize = "md" | "lg" | "xl";

export type SettingsState = {
  textSize: TextSize;
  contrastMode: boolean;
  tosAccepted: boolean;
}

const initialState: SettingsState = {
  textSize: "md",
  contrastMode: false,
  tosAccepted: false,
};


export const SettingsStore = signalStore(
  { providedIn: "root" },
  withImmutableState(initialState),
  withDevtools("settings"),
  withStorageSync({ key: "chatbot-settings" }),
  withMethods((store) => ({
    async patch(settings: Partial<SettingsState>): Promise<void> {
      if(settings.contrastMode !== undefined) {
        setContrastMode(settings.contrastMode);
      }
      patchState(store, state => ({ ...state, ...settings }));
    },
    async reset(): Promise<void> {
      patchState(store, initialState);
    },
  })),
  withHooks({
    onInit(store) {
      const contrastService = new HighContrastService();
      contrastService.set(store.contrastMode());
    },
  }),
);

function setContrastMode(enabled: boolean) {
  const contrastService = new HighContrastService();
  contrastService.set(enabled);
}
